<template>
  <div class="home max">
    <div class="banner">
      <img class="banner_img" src="../../static/img/xxpl_banner.png" alt="">
    </div>
    <div class="content w1200">
      <ul class="con_left">
        <img src="../../static/img/xxpl_xxpl.png" alt="">
        <li v-for="(item, i) in xpList" :key="i" @mousemove="active = i" :class="{ active: active === i }">
          {{ item.name }}
        </li>
      </ul>
      <div class="con_right">
        <div v-for="(item, i) in xpContent" :key="i"
          v-if="active === i && active != 1 && active != 2 && active != 4 && active != 5">
          <h4>{{ item.title }}</h4>
          <!-- <div></div> -->
          <p>{{ item.text }}</p>
          <p>{{ item.text1 }}</p>
          <p>{{ item.text2 }}</p>
          <p>{{ item.text3 }}</p>
          <p>{{ item.text4 }}</p>
          <p>{{ item.text5 }}</p>
          <p>{{ item.text6 }}</p>
          <p>{{ item.text7 }}</p>
          <p>{{ item.text8 }}</p>
          <p>{{ item.text9 }}</p>
          <p>{{ item.text10 }}</p>
          <p>{{ item.text11 }}</p>
          <p>{{ item.text12 }}</p>
          <p>{{ item.text13 }}</p>

        </div>

        <div class="nr" v-if="active === 1">

          <h4>互联网业务(自营)基本情况</h4>
          <table width="870" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>机构中文全称</td>
              <td> 天津协和万邦保险经纪有限公司</td>
              <td>机构中文简称</td>
              <td>协和万邦</td>
            </tr>
            <tr>
              <td>机构英文全称</td>
              <td>无</td>
              <td>机构英文简称</td>
              <td>无</td>
            </tr>
            <tr>
              <td>注册资本（万元</td>
              <td>5000万元</td>
              <td>设立时间（年/月/日）</td>
              <td>2008/10/22</td>
            </tr>
            <tr>
              <td scope="col">机构具体地址</td>
              <td colspan="3" scope="col">天津市武清开发区福源道北侧</td>
            </tr>
            <tr>
              <td colspan="2">经营互联网保险业务的网站名称</td>
              <td colspan="2">无</td>
            </tr>
            <tr>
              <td colspan="2">经营互联网保险业务的网站地址</td>
              <td colspan="2">无</td>
            </tr>
            <tr>
              <td colspan="2">经营互联网保险业务的APP名称</td>
              <td colspan="2" style="text-align:left;">
                停有钱；小二保险；飞猪保险；利车保；热保；联合保；紫尊保；太慧宝；鼎龙宝；协保宝；小麦车险；天津协和万邦保险经纪有限公司（支付宝小程序）</td>
            </tr>
            <tr>
              <td colspan="2">经营互联网保险业务的微信公众号名称</td>
              <td colspan="2">领保万邦</td>
            </tr>
            <tr>
              <td colspan="2">客户服务及消费者投诉电话</td>
              <td colspan="2">400-665-0265</td>
            </tr>
            <tr>
              <td colspan="2">公司信息披露网站地址</td>
              <td colspan="2">http://www.feizhubaoxian.com/</td>
            </tr>
            <tr>
              <td>公司管理员姓名</td>
              <td>杨晓强</td>
              <td>公司管理员座机（加区号）</td>
              <td>010-68973668</td>
            </tr>
            <tr>
              <td>公司管理员手机</td>
              <td>13810174838</td>
              <td>公司管理员微信号</td>
              <td>Xuelang_0521</td>
            </tr>
            <tr>
              <td>公司管理员部门</td>
              <td>商务部</td>
              <td>公司管理员职务</td>
              <td> </td>
            </tr>
            <tr>
              <td>公司管理员邮箱</td>
              <td>13810174838@163.com</td>
              <td>公司负责领导 （直接责任人）

              </td>
              <td>梁宗伟</td>
            </tr>
            <tr>
              <td>公司负责领导座机</td>
              <td>010-68973668</td>
              <td>公司负责领导手机</td>
              <td>180001311298</td>
            </tr>
          </table>
        </div>
        <div class="nr" v-if="active === 2">

          <h4>自营网络平台（APP）产品信息</h4>
          <table width="870" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>实际销售名称</td>
              <td>备案产品名称</td>
              <td>备案编号/批复文号</td>
              <td>承保保险公司名称</td>
            </tr>
            <tr>
              <td>销售产品名称</td>
              <td>备案名称</td>
              <td>备案编号</td>
              <td>承保公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2016〕568号</td>
              <td>安盛天平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>安盛天平财产保险股份有限公司</td>
            </tr>

            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>中国人民财产保险股份有限公司</td>
            </tr>

            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>银保监许可〔2018〕788号 </td>
              <td>中国人民财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>中华联合财产保险股份有限公司</td>
            </tr>

            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2017〕 732号</td>
              <td>中华联合财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>紫金财产保险股份有限公司</td>
            </tr>

            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2017〕 822号</td>
              <td>紫金财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>利宝保险有限公司</td>
            </tr>

            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>利宝保险有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>太平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2016〕572号</td>
              <td>太平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>紫金财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2017〕 822号</td>
              <td>紫金财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>保监产险〔2008〕1219号</td>
              <td>鼎和财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>银保监许可〔2018〕938号</td>
              <td>鼎和财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>中国人民财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险 </td>
              <td>机动车综合商业保险条款</td>
              <td>银保监许可〔2018〕788号 </td>
              <td>中国人民财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号 </td>
              <td>中国人民财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>银保监许可〔2018〕788号</td>
              <td>中国人民财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>中华联合财产保险股份有限公司
              </td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2017〕 732号</td>
              <td>中华联合财产保险股份有限公司
              </td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>利宝保险有限公司
              </td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2016〕404号</td>
              <td>利宝保险有限公司
              </td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2016〕568号</td>
              <td>安盛天平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>安盛天平财产保险股份有限公司</td>
            </tr>

            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>紫金财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2017〕 822号</td>
              <td>紫金财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>太平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2016〕572号</td>
              <td>太平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>太平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>银保监许可〔2018〕176号</td>
              <td>太平财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>大地财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2016〕314号</td>
              <td>大地财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车交通事故责任强制保险</td>
              <td>机动车交通事故责任强制保险条款</td>
              <td>中保协条款[2006]1号</td>
              <td>天安财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>机动车综合商业保险</td>
              <td>机动车综合商业保险条款</td>
              <td>保监许可〔2015〕1256号</td>
              <td>天安财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>平安交强险</td>
              <td>机动车交通事故责任强制保险</td>
              <td>银保监复【2020】617号</td>
              <td>中国平安财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>众安平安联合车险（保骉车险）</td>
              <td>众安在线财产保险股份有限公司机动车商业保险示范条款（2020版）</td>
              <td style='width:196px;'>(众安在线)(备-机动车辆保险)【2020】(主) 059号、(主) 060号、(主) 065号、(众安在线)(备-机动车辆保险)【2020】(附) 047号、(附)
                049号、(附) 051号、(附) 056号、(附) 061号、(附) 063号、(附) 064号、(附) 065号、(附) 069号、(附) 071号、(附) 073号</td>
              <td>众安在线财产保险股份有限公司<br />中国平安财产保险股份有限公司</td>
            </tr>
            <tr>
              <td>众安平安联合车险（保骉车险）</td>
              <td>众安在线财产保险股份有限公司特种车商业保险示范条款（2020版）</td>
              <td>(众安在线)(备-机动车辆保险)【2020】(主) 061号、(主) 062号、(主) 067号、(主) 068号、(众安在线)(备-机动车辆保险)【2020】(附) 048号、(附) 054号、(附)
                058号、(附) 059号、(附) 062号、(附) 067号、(附) 068号、(附) 070号、(附) 077号</td>
              <td>众安在线财产保险股份有限公司<br />中国平安财产保险股份有限公司</td>
            </tr>

          </table>
        </div>
        <!-- </div> -->

        <div v-if="active === 4">
          <!-- <h4 >1111111111111</h4> -->
          <!-- @click="clickFun" -->
          <h4>网销产品</h4>
          <table width="870" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>保险公司</td>
              <td>产品名称</td>
              <td>产品条款</td>
              <td>费率信息</td>
              <td>备案说明</td>
            </tr>
            <template v-for="item in getData.list">
              <tr>
                <td style="width: 150px;">{{ item.fullName }}</td>
                <td style="width: 150px;">{{ item.name }}</td>

                <td style="width:150px;">
                  <div style=" width: 100%;">
                    <div v-for='item2 in item.cptkList'>
                      <span @click="cptkFun(item.fullPrefix, item2.docUrl)"
                        class="arrayListClass">{{ item2.subName }}</span><br />
                    </div>
                  </div>
                </td>

                <td style="width:150px;">
                  <div style="width: 100%;">
                    <div v-for='item2 in item.flbList'>
                      <span @click="cptkFun(item.fullPrefix, item2.docUrl)"
                        class="arrayListClass">{{ item2.subName }}</span><br />
                    </div>
                  </div>
                </td>

                <td>
                  <div style="max-height: 150px; overflow-y: auto;">
                    <div v-for='item4 in item.filingInformation'>
                      <span class="arrayListClass">{{ item4.filingName }}<br /> 备案号：{{ item4.filingNum }}</span><br />
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </table>
        </div>

        <div class="nr" v-if="active === 5">
          <h4>公告</h4>
          <div style="text-indent:2em; line-height:28px;">
            天津协和万邦保险经纪有限公司江苏分公司，统一社会信用代码91320891MA1WF3K05R,因业务发展需要于2023年11月20日变更办公地址为南京市玄武区玄武大道699-17号2幢4楼405B。</div>
          <div style="text-indent:2em; margin-top:10px;">其他联系方式未有变动，由此带来的不便请予谅解。</div>
          <div style="text-indent:2em; margin-top:10px;">特此公告</div>
          <div style="line-height:26px; margin-top:10px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />2023年11月30日</div>
          <div style="clear:both;"></div>
        </div>

        <div class="nr" v-if="active === 6">
          <h4>公告</h4>
          <div style="text-indent:2em; line-height:28px;">
            天津协和万邦保险经纪有限公司深圳分公司，统一社会信用代码91440300MA5GT7WE6M，因业务发展需要于2024年5月10日变更办公地址为深圳市龙华区龙华街道油松社区水斗新围村永顺通商业大厦102。</div>
          <div style="text-indent:2em; margin-top:10px;">其他联系方式未有变动，由此带来的不便请予谅解。</div>
          <div style="text-indent:2em; margin-top:10px;">特此公告</div>
          <div style="line-height:26px; margin-top:10px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />2024年5月17日</div>
          <div style="clear:both;"></div>
        </div>

        <div class="nr" v-if="active === 7">
          <h4>公告</h4>
          <div style="text-indent:2em; line-height:28px;">
            天津协和万邦保险经纪有限公司青岛市南分公司，统一社会信用代码91370202MA3M18TB4L,于2024年9月14日办理完工商登记注销手续。</div>
          <div style="text-indent:2em; margin-top:10px;">由此带来的不便请予谅解。</div>
          <div style="text-indent:2em; margin-top:10px;">特此公告</div>
          <div style="line-height:26px; margin-top:10px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />2024年9月18日</div>
          <div style="clear:both;"></div>
        </div>

        <div class="nr" v-if="active === 8">
          <h4>公告</h4>
          <div style="text-indent:2em; line-height:28px;">
            天津协和万邦保险经纪有限公司河南分公司，统一社会信用代码91410522MA45HDFP75, 因公司业务发展需要于2025年04月15日变更分公司负责人，由汪君变更为王天然。其他未有变动，由此带来的不便请予谅解。</div>
          <div style="text-indent:2em; margin-top:10px;">特此公告</div>
          <div style="line-height:26px; margin-top:10px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />2025年04月16日</div>
          <div style="clear:both;"></div>
        </div>

        <div class="nr" v-if="active === 9">
          <h4>公告</h4>
          <div style="text-indent:2em; line-height:28px;">
            天津协和万邦保险经纪有限公司新疆分公司，统一社会信用代码91652301MA77864M1G,于2025年05月12日办理完工商登记注销手续。</div>
          <div style="text-indent:2em; margin-top:10px;">由此带来的不便请予谅解。</div>
          <div style="text-indent:2em; margin-top:10px;">特此公告</div>
          <div style="line-height:26px; margin-top:10px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />2025年06月06日</div>
          <div style="clear:both;"></div>
        </div>

        <div class="nr" v-if="active === 10" style="width:885px;">
          <h4>公告</h4>

                    <!-- <h4>公告</h4> -->
          <div style="line-height:28px; text-indent: 2em;">
            （呼新城）注销登字(2026)第00014859号，天津协和万邦保险经纪有限公司内蒙古分公司:</div>
          <div style="margin-top:10px;">你单位提交的<span style="text-decoration: underline;">注销</span>登记申请材料齐全，符合法定形式，我局予以登记。</div>
          <div style="text-indent:2em; margin-top:10px;">
            由此带来的不便请予谅解。
          </div>
          <div style="text-indent:2em; margin-top:10px;">
            特此公告
          </div>
          <div style="line-height:26px; margin-top:20px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />
            2026年01月22日</div>
          <div style="clear:both;"></div>
        </div>

        <div class="nr" v-if="active === 11">
          <h4>公告</h4>
          <div style="text-indent:2em; line-height:28px;">
            天津协和万邦保险经纪有限公司山东分公司，统一社会信用代码91370704MA3C0XH44R, 因公司业务发展需要，变更分公司负责人，由梁宗伟变更为王学谦。其他未有变动，由此带来的不便请予谅解。</div>
          <div style="text-indent:2em; margin-top:10px;">特此公告</div>
          <div style="line-height:26px; margin-top:10px; text-align:center; width:310px; float:right;">
            天津协和万邦保险经纪有限公司<br />2026年05月19日</div>
          <div style="clear:both;"></div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      getData: '',
      active: 0,
      xpList: [
        {
          name: "经营承诺书"
        },
        {
          name: "（自营）基本情况"
        },
        {
          name: "（网站）产品信息"
        },
        {
          name: "客户告知书"
        },
        {
          name: "网销产品"
        },
        {
          name: "江苏分公司迁址"
        },
        {
          name: "深圳分公司迁址"
        },
        {
          name: "青岛南分公司注销"
        },           
        {
          name: "河南分公司变更负责人"
        },
        {
          name: "新疆分公司注销"
        },  
        {
          name: "内蒙古分公司注销"
        },  
        {
          name: "山东分公司变更负责人"
        },
      ],
      xpContent: [
        {
          id: 0,
          title: "互联网保险业务规范经营承诺书",
          text:
            "为有效保护消费者权益，共同维护互联网保险市场健康可持续发展，本公司承诺如下：",
          text1:
            "一、我们将严格遵守相关法律和规定，秉持最大诚信原则，规范从事互联网保险经营活动。",
          text2:
            "二、本公司以及第三方合作平台的网站、APP、微信号等互联网工具，均达到监管制度要求和技术要求，不存在违反规定和重大缺陷、隐患情形。",
          text3:
            "三、我们与第三方网络平台合作建立了完善的合作制度和风险管控体系，能有效抑制销售误导、恶意欺诈等行为，可以为消费者营造安全放心的交易环境。",
          text4:
            "四、互联网保险业务的销售、承保、理赔、退保、投诉处理及客户服务等保险经营行为，均由本公司管理和负责，不具有保险业务资格的第三方网络平台仅提供网络技术支持辅助服务。",
          text5:
            "本公司保证所提供材料真实、完整，自觉接受监管部门和行业组织的监督管理。本公司承诺对互联网保险业务经营行为承担完全法律责任。"
        },
        {
          id: 1
          // title: '',
        },
        {
          id: 2
          // title: '自营网络平台（网站）产品信息',
        },
        {
          id: 3,
          title: "客户告知书",
          text: "尊敬的客户：",
          text1:
            "感谢您选择我公司为您办理保险业务。本公司是依据投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构，按照《保险经纪机构监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读。",
          text2: "一、公司基本情况",
          text3: "（一）名称:天津协和万邦保险经纪有限公司",
          text4: "（二）机构住所：天津市武清开发区福源道北侧",
          text5:
            "（三）许可证名称及机构编码： 经营保险经纪业务许可证，2605540000800",
          text6: "（四）许可证有效期至：2027年09月29日",
          text7:
            "（五）业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务。",
          text8: "（六）联系方式：4006650265",
          text9:
            "二、请仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等内容，并可要求本公司业务人员对上述内容进行详细讲解。",
          text10:
            "三、请向本公司业务人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。",
          text11:
            "四、根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。",
          text12:
            "五、本公司已按《保险专业经纪机构监管规定》投保职业责任保险。",
          text13:
            "六、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向保监局或当地保险行业协会反映。"
        },
        {
          id: 4

        },
        {
          id: 5
        }
      ]
    };
  },
  methods: {
    clickFun() {
      // https://m.xiehewanbang.com/mall/product/getInsuranceProductMessage
      //本地测试 把域名去掉，打包的时候加上域名
      this.$axios.post(
        'https://m.xiehewanbang.com/mall/product/getInsuranceProductMessage', {
        "pageSize": "100",
        "pageNum": "1"
      }).then((str) => {
        if (str.data.status == 200) {
          this.getData = str.data.data;
          console.log('getdata', this.getData);
        } else {
          alert(str.data.message);
        }
      });
    },
    cptkFun(url, str) {
      window.open(url + str);

    },



  },
  mounted() {

    this.clickFun();
  }

};
</script>

<style  lang="scss" scoped>
.content {
  background-color: #fff;
  padding: 60px 10px;
  display: flex;
  justify-content: space-between;

  .con_left {
    height: 1092px;
    width: 223px;
    background-color: #5182c4;

    li {
      text-align: center;
      height: 60px;
      line-height: 60px;
      margin-top: 20px;
      font-weight: 600;
      color: #fffcfa;
    }

    .active {
      background-color: #f4f4f4;
      color: #5786b0;
    }
  }

  .con_right {
    padding: 0 40px;
    color: #656565;

    h4 {
      font-size: 28px;
      color: #598ac2;
      text-align: center;
      // line-height: 96px;
      padding-bottom: 40px;
    }

    p {
      padding-bottom: 10px;
      text-indent: 2em;
    }

    table {
      font-size: 18px;
      color: #606060;

      td {
        padding: 5px;
        text-align: center;
      }
    }
  }
}

.arrayListClass {
  cursor: pointer;
  font-size: 12px;
  line-height: 14px;
  display: inline-block;
  padding-bottom: 6px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/Disclosure.vue